<template>
  <div>
    <b-skeleton-wrapper :loading="isBusy">
      <template #loading>
        <b-card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </b-card>
      </template>
    </b-skeleton-wrapper>

    <div v-if="!isBusy">
      <b-card v-if="user && user.name">
        <b-card-title>
          Добро пожаловать, {{ user.name }}!
        </b-card-title>
        <b-card-text>
          Логин: {{ user.username }} <br/>
          Роль: {{ user.role_name }} <br/>
          Email: {{ user.email }}
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
import users from "../../network/users";
  import helpers from "../../utilites/helpers";

export default {
  name: "Home",
  mixins: [
    users,
    helpers
  ],
  data() {
    return {
      isBusy: true,
      user: null,
    }
  },
  async created() {
    this.isBusy = true;
    const result = await this.getUserInfo();
    this.isBusy = false;

    if (this.$route.name === 'Login') {
      return;
    }

    if (!result && result.data == null) {
      this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
      return;
    }
    this.user = result.data;
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue